import { OptionGroup } from './olo.optiongroup';

export class Modifiers {
  optiongroups: OptionGroup[];
}
